enum TabbedFlipboardCardTypeEnum {
  Media = 'media',
  Text = 'text',
  Split = 'split',
  SmallMedia = 'smallmedia',
  SmallText = 'smalltext',
}

export default TabbedFlipboardCardTypeEnum;
